import { SVGProps } from 'react';

export const SvgTotalRevenue = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} viewBox="0 0 16 16" fill="none" {...props}>
    <path d="M2 2V14H14M12.6667 6L9.33333 9.33333L6.66667 6.66667L4.66667 8.66667" stroke="currentColor" strokeWidth={1.2} strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);
